import type { ThemeOptions } from '@mui/material';

const OutlinedInputTheme: ThemeOptions['components'] = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        height: '32px',
      },
    },
  },
};

export default OutlinedInputTheme;
